import BaseModel3d from '../BaseModel3d';
import { globalStores } from '@/editor/stores';
import { pixelRatio3d } from '@/editor/math/const';
import { IBaseDataHoleFace, IFaceData } from '@/editor/data/face/face';
import { EEntityType } from '@/editor/types';
import { EContainerType } from '@/editor/types/entity';
import { BufferAttribute, BufferGeometry, Mesh } from 'three';
import { createMaterial } from '@/editor/data/material/utils';

export class HoleFaceModel extends BaseModel3d {
  constructor(options: { id: string }) {
    super({ id: options.id });

    this.model.userData.type = EEntityType.Face;
    this.model.userData.containerType = EContainerType.entity;
    this.model.userData.entityId = this._id;

    globalStores.editorStateStore.sceneInfo.scene3d.intersectableGroup.add(this.model);
  }

  createModel(faceData: IFaceData) {
    if (!this.canUpdate) return;

    this.clearModel();

    this.model.add(this.createPlane(faceData));

    this.updateWithoutDestroy(faceData);
  }

  updateWithoutDestroy(faceData: IFaceData) {
    if (!this.canUpdate) return;

    const { center, width, thickness, height, offGround, rotation } = faceData.baseData as IBaseDataHoleFace;

    this.model.position.set(center.x / pixelRatio3d, center.y / pixelRatio3d, offGround / pixelRatio3d);
    this.model.scale.set(width / pixelRatio3d, thickness / pixelRatio3d, height / pixelRatio3d);
    this.model.rotation.set(0, 0, rotation);
  }

  private createPlane(faceData: IFaceData) {
    const material = createMaterial(faceData.materialInfo.id);

    const bufferGeometry = new BufferGeometry();
    bufferGeometry.setAttribute(
      'position',
      new BufferAttribute(
        new Float32Array([
          // 底部
          -0.5, -0.5, 0, 0.5, -0.5, 0, 0.5, 0.5, 0, 0.5, 0.5, 0, -0.5, 0.5, 0, -0.5, -0.5, 0,
          // 顶部
          -0.5, -0.5, 1, 0.5, 0.5, 1, 0.5, -0.5, 1, -0.5, 0.5, 1, 0.5, 0.5, 1, -0.5, -0.5, 1,
          // 左侧
          -0.5, -0.5, 0, -0.5, 0.5, 0, -0.5, 0.5, 1, -0.5, 0.5, 1, -0.5, -0.5, 1, -0.5, -0.5, 0,
          // 右侧
          0.5, -0.5, 0, 0.5, 0.5, 1, 0.5, 0.5, 0, 0.5, -0.5, 1, 0.5, 0.5, 1, 0.5, -0.5, 0
        ]),
        3
      )
    );
    bufferGeometry.setAttribute(
      'normal',
      new BufferAttribute(
        new Uint16Array([
          // 底部
          0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1,
          // 顶部
          0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1,
          // 左侧
          1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0,
          // 右侧
          -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0
        ]),
        3
      )
    );

    return new Mesh(bufferGeometry, material);
  }
}
